import { ObjectAny } from '@lib/interfaces';

export default function objectToQueryString(params: ObjectAny) {
  return Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');
}
